var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        close: _vm.close,
        printStyle: _vm.printStyle,
        title: _vm.title,
        printButton: "",
        downloadButton: "",
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-credit-card" }),
          _vm._v("  Решения о блокировке расчётных счетов.\n    "),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "htmlContent",
          staticClass: "modal__content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          _c("block-invoices-table", {
            staticClass: "show-on-print",
            attrs: {
              list: _vm.actualList,
              actualDate: _vm.actualDate,
              inModal: "",
            },
          }),
          _vm._v(" "),
          _c("block-invoices-table", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.archiveList.length,
                expression: "archiveList.length",
              },
            ],
            class: { "show-on-print": _vm.archiveList.length },
            attrs: {
              list: _vm.archiveList,
              actualDate: _vm.actualDate,
              inModal: "",
              archived: "",
            },
          }),
          _vm._v(" "),
          _c("block-invoices-history", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.historyList.length,
                expression: "historyList.length",
              },
            ],
            class: { "show-on-print": _vm.historyList.length },
            attrs: { list: _vm.historyList, inModal: "" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }